export default __webpack_public_path__ + "static/media/drysuit.48b1aa4e.jpg";